import React from 'react';
// components
import CCCStandardForm from '../../forms/CCCStandardForm';
import Modal from 'shared/modals/Modal';

const CCCStandardModal = ({
  onClose,
  values,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {
  return (
    <Modal isOpen={true} title={`${values && values.id ? 'Edit' : 'Add'} CCC Standard`} handleClose={onClose} containerStyle='medium'>
      <section className={`ccc-standard-form ${isSubmitting ? 'hide-overflow' : ''}`}>
        <CCCStandardForm data={initialValues} onClose={onClose} setSubmitting={setSubmitting}></CCCStandardForm>
      </section>
    </Modal>
  );
};

export default CCCStandardModal;
